/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsCollectionList = {
    init: function ($section) {     
      this.$section = $section;
      // Add settings from schema to current object
      Shopify.theme.jsCollectionList = $.extend(this, Shopify.theme.getSectionData($section));

      let $sliderEl = $section.find('[data-slider]');      
      let showMobileSlider = this.show_slider_mobile;
      if (!isScreenSizeLarge() && showMobileSlider == true) {
        this.createSlider($sliderEl);
      }
    },
    createSlider: function ($sliderEl) {

      let $progressBar = this.$section.find('.progress-bar');

      const slider = $sliderEl.flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        pageDots: false,
        contain: true,
        prevNextButtons: false,
        initialIndex: 0,
        arrowShape: arrowShape,
        on: {          
          scroll: function(progress) {          
            progress = Math.max( 0.1, Math.min( 1, progress ) );
            $progressBar.css('width', (progress * 100) + "%");
          }
        }
      });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });      

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;